export default "__VITE_ASSET__cf4ebf01__"